import { Box, styled } from '@arpeggi/ui'

const Root = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  alignItem: 'center',
  justifyContent: 'center',
  padding: '18px 12px',
  backgroundColor: 'rgba(0, 0, 0, 0.05)',
  marginTop: '16px',
  borderRadius: '20px',
  minWidth: '375px'
})

const NumberContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  margin: '0px 12px'
})

const Number = styled(Box, {
  textAlign: 'center',
  fontSize: '40px',
  textFamily: 'dm-bold',
  lineHeight: '48px'
})

const Label = styled(Box, {
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '20px'
})

export const Clock = { Root, NumberContainer, Number, Label }
